import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=70b7162d&scoped=true"
import script from "./PasswordResetView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordResetView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PasswordResetView.vue?vue&type=style&index=0&id=70b7162d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b7162d",
  null
  
)

export default component.exports